import { AbstractModel } from './AbstractModel'

export class Country extends AbstractModel {
    public id: number|null = null;
    public name: string|null = null;
    public isoCode2: string|null = null;
}
